<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">
      {{ modalTitle || ('shared.push_notification.titoloDefault' | transloco) }}
    </ion-title>
  </ion-toolbar>

  @if (modalMessage) {
    <div class="ion-padding messaggio-container">
      <ion-label class="fs-pt-14">
        {{ modalMessage }}
      </ion-label>
    </div>
  }

  <div class="ion-padding-horizontal ion-padding-bottom">
    @if (route) {
      <ion-button
        expand="block"
        color="primary"
        class="ion-margin-top ion-text-uppercase"
        (click)="open()">
        {{ 'shared.push_notification.apri' | transloco }}
      </ion-button>
    }

    <ion-button
      expand="block"
      color="danger"
      class="ion-margin-top ion-text-uppercase"
      (click)="close()">
      {{ 'common.action.close' | transloco }}
    </ion-button>
  </div>
</div>
